import { Identifiable, Event } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByTags(
  { tags }: Identifiable<Event>,
  { projectsElementsTags }: Filter,
): boolean {
  return (
    !!projectsElementsTags &&
    projectsElementsTags.length > 0 &&
    !projectsElementsTags.find(
      (tag) =>
        tags.length > 0 &&
        tags.find((t) => (t.name || t) === (tag.name || tag)),
    )
  );
}

export { isFilteredByTags };
